<template>
    <div>
        <div class="col-md-12">
            <form  @submit.prevent="searchData()" role="form">
                <div class="row">
                    <div class="col-2">

                        <input type="text"
                               class="form-control"
                               v-model="pagingInfo.search"
                               placeholder="Register No." />

                    </div>
                    <div class="col-2">
                        <select name="Type" v-model="pagingInfo.type" class="form-control">
                            <option value>Select Type</option>
                            <option v-for="option in types"
                                    v-bind:value="option.realEstateType"
                                    v-bind:key="option.realEstateType">
                                {{ option.realEstateType }}
                            </option>
                        </select>
                    </div>
                    <div class="col-2">

                        <select id="region"
                                class="form-control"
                                v-model="pagingInfo.mydata">
                            <option value="0">All Data</option>
                            <option value="1">My Encodes</option>
                        </select>

                    </div>
                    <div class="col-2">

                        <button type="submit" class="btn btn-info ">
                            <strong>Search</strong>
                        </button>&nbsp;
                        <button type="button" v-on:click="clearControls()" class="btn btn-primary">Clear</button>

                    </div>
                </div>
                
            </form>
            <br />

            <div class="box">
                <div class="box-header"></div>
                <div class="box-body table-responsive no-padding">
                    <table class="table table-striped table-bordered table-hover">
                        <thead>
                            <tr>
                                <th>Type</th>
                                <th>Register No</th>
                                <th>Country</th>
                                <th>State</th>
                                <th>City</th>
                                <th>Postal Code</th>
                                <th>Comments</th>
                                <th>Created By</th>
                                <th>
                                    <a @click="sort('DateCreated')">Date Created</a>
                                </th>
                                <th>Updated By</th>
                                <th>
                                    <a @click="sort('DateUpdated')">Date Updated</a>
                                </th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="doc in docs" v-bind:key="doc.id">
                                <td>{{ doc.type | capitalize }}</td>
                                <td>{{ doc.registerNo }}</td>
                                <td>{{ doc.country }}</td>
                                <td>{{ doc.state }}</td>
                                <td>{{ doc.city }}</td>
                                <td>{{ doc.postalCode }}</td>
                                <td>{{ doc.comments }}</td>
                                <td>{{ doc.createdBy }}</td>
                                <td>{{ doc.dateCreated | formatDate }}</td>
                                <td>{{ doc.updatedBy }}</td>
                                <td>{{ doc.dateUpdated | formatDate }}</td>
                                <td v-if="$store.getters.LINKMODE">
                                    <button class="btn btn-sm btn-success"
                                            @click="setLink(doc.id)">
                                        Link Object
                                    </button>
                                </td>
                                <td v-else-if="$store.getters.CRAD">
                                    <TheDropDownButton>
                                        <btn @click.native="editReal(doc.id)"
                                             icon="fa fa-pencil-alt"
                                             title="Edit"></btn>
                                        <btn @click.native="More(doc)"
                                             icon="fa fa-expand-alt"
                                             title="View Linkages"></btn>
                                        <btn @click.native="addtoMerge(doc)"
                                             icon="fa fa-code-branch"
                                             title="Merge Record"></btn>
                                    </TheDropDownButton>
                                </td>
                                <td v-else-if="$store.getters.VIEWER">
                                    <TheDropDownButton>
                                        <btn @click.native="More(doc)"
                                             icon="fa fa-expand-alt"
                                             title="View Linkages"></btn>
                                    </TheDropDownButton>
                                </td>
                                <td v-else>
                                    <TheDropDownButton>
                                        <btn v-if="mydata"
                                             @click.native="editFireArm(doc.id)"
                                             icon="fa fa-pencil-alt"
                                             title="Edit"></btn>
                                        <btn @click.native="More(doc)"
                                             icon="fa fa-expand-alt"
                                             title="View Linkages"></btn>
                                    </TheDropDownButton>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div v-show="totalitems == 0" class="alert alert-warning">
                        <p>Found no result try again</p>
                    </div>
                </div>
            </div>

            <b-pagination v-model="pagingInfo.page"
                          v-on:input="fetchData()"
                          :total-rows="totalitems"
                          :per-page="pagingInfo.itemsPerPage"
                          first-text="First"
                          prev-text="Prev"
                          next-text="Next"
                          last-text="Last"></b-pagination>
        </div>
        <div>
            <b-modal id="LinkPopupRE" title="Link Builder" scrollable hide-footer>
                <LinkPopUp />
            </b-modal>
            <b-modal id="EditPopUPRE"
                     title="Edit Real Estate"
                     size="lg"
                     scrollable
                     hide-footer>
                <EditRealEstate v-bind:id="RealID" v-on:done-edit-real="doneEdit()" />
            </b-modal>

            <b-modal id="linkpopupre" size="xl" scrollable hide-footer>
                <LinkComponentPopRe v-bind:id="linkid"
                                    v-bind:linkdescription="linkdescription" />
            </b-modal>
            <b-modal id="mergerecordre"
                     size="md"
                     hide-footer
                     ref="merger"
                     no-close-on-esc="true"
                     no-close-on-backdrop="true"
                     hide-header-close="true">
                <MergePopUpre v-bind:obj1ID="obj1Id"
                            v-bind:obj2ID="obj2Id"
                            v-bind:obj1Desc="obj1description"
                            v-bind:obj2Desc="obj2description"
                            v-bind:objType="objType"
                            v-on:done="done()"
                            v-on:cancel="cancel()" />
            </b-modal>
        </div>
    </div>
</template>

<script>
    import {
        authHeader,
        responseCheck,
        RecordURL,
        setObject2Link,
        RequestLink,
        getlocalstorageRealEstateType,
        notifyHelper
    } from "../helper";
    import LinkPopUp from "./master/Linking";
    import EditRealEstate from "./edit/RealEstate";
    import btn from "./buttons/iconButton";
    import LinkComponentPopRe from "./link/linkcomponent";
    import MergePopUpre from "./master/recordMerge";
    import instance from "../helper/http";
    export default {
        data() {
            return {
                docs: [],
                pagingInfo: {
                    page: 1,
                    search: "",
                    sortBy: "",
                    reverse: false,
                    mydata: 0,
                    type: ""
                },
                totalitems: null,
                RealID: "",
                mydata: false,
                linkid: "",
                linkdescription: "",
                obj1Id: "",
                obj2Id: "",
                objType: "",
                obj1description: "",
                obj2description: "",
                hasfirst: false,
                types: []
            };
        },
        components: {
            LinkPopUp,
            EditRealEstate,
            btn,
            LinkComponentPopRe,
            MergePopUpre
        },
        created: function () {
            this.getlibs();
        },
        methods: {
            async requestlinkdownload(id) {
                await RequestLink(id);
            },
            getlibs() {
                
                this.types = getlocalstorageRealEstateType();
            },
            clearControls() {
                this.pagingInfo.search = "";
                this.pagingInfo.mydata = 0;
            },
            addtoMerge(data) {
                var additional =
                    (data.type ? data.type : "") +
                    " " +
                    (data.registerNo ? data.registerNo : "");
                additional = additional.replace(/\//g, "-");
                if (this.hasfirst) {
                    if (this.obj1Id == data.id) {
                        notifyHelper("info", "Cannot merge the same real estate");
                    }
                    else {
                        this.obj2description = additional;
                        this.obj2Id = data.id;
                        this.objType = "RE"
                        //open the popup
                        this.$bvModal.show("mergerecordre");
                    }

                } else {
                    this.obj1description = additional;
                    this.obj1Id = data.id;
                    this.hasfirst = true;
                    notifyHelper(
                        "success",
                        "Add to merging of record, please choose another record to merge"
                    );
                }
            },
            cancel() {
                this.$bvModal.hide("mergerecordre");
                this.hasfirst = false;
                this.obj1Id = "";
                this.obj2Id = "";
                this.obj1description = "";
                this.obj2description = "";
            },
            done() {
                this.$bvModal.hide("mergerecordre");
                this.hasfirst = false;
                this.obj1Id = "";
                this.obj2Id = "";
                this.obj1description = "";
                this.obj2description = "";
                this.fetchData();
            },
            fetchData() {
                if (this.pagingInfo.mydata == "0") this.mydata = false;
                else this.mydata = true;

                instance
                    .get(RecordURL + "getrealestate", {
                        headers: authHeader(),
                        params: this.pagingInfo,
                    })
                    .then((response) => {
                        this.docs = response.data.data;
                        this.totalitems = response.data.count;
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                        this.mydata = false;
                        this.docs = [];
                        this.totalitems = 0;
                    });
            },
            searchData() {
                this.pagingInfo.page = 1;
                this.fetchData();
            },
            More: function (data) {
                var additional1 = (data.type ? data.type : '') + " " + (data.registerNo ? data.registerNo : '')
                additional1 = additional1.replace(/\//g, "-");
                // this.$router.replace({
                //   name: "Links",
                //   params: { id: data.id, description: additional1 },
                // });
                this.linkid = data.id;
                this.linkdescription = additional1;
                this.$bvModal.show("linkpopupre");
            },
            sort: function (sortBy) {
                if (sortBy === this.pagingInfo.sortBy) {
                    this.pagingInfo.reverse = !this.pagingInfo.reverse;
                } else {
                    this.pagingInfo.sortBy = sortBy;
                    this.pagingInfo.reverse = false;
                }
                this.pagingInfo.page = 1;
                this.fetchData();
            },
            setLink: function (id) {
                setObject2Link(id, "RE");
                this.$bvModal.show("LinkPopupRE");
            },
            editReal: function (id) {
                this.RealID = id;
                //modal
                this.$bvModal.show("EditPopUPRE");
            },
            doneEdit() {
                this.$bvModal.hide("EditPopUPRE");
            },
        },
    };
</script>

